import { render, staticRenderFns } from "./BookingCommoditiesStandard.vue?vue&type=template&id=927ce2c6&scoped=true&"
import script from "./BookingCommoditiesStandard.vue?vue&type=script&lang=js&"
export * from "./BookingCommoditiesStandard.vue?vue&type=script&lang=js&"
import style0 from "./BookingCommoditiesStandard.vue?vue&type=style&index=0&id=927ce2c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927ce2c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('927ce2c6')) {
      api.createRecord('927ce2c6', component.options)
    } else {
      api.reload('927ce2c6', component.options)
    }
    module.hot.accept("./BookingCommoditiesStandard.vue?vue&type=template&id=927ce2c6&scoped=true&", function () {
      api.rerender('927ce2c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/booking/BookingCommoditiesStandard.vue"
export default component.exports